import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import ItemGeneralDataContainer from './ItemGeneralDataContainer';
import ItemPropertiesContainer from './property/ItemPropertiesContainer';

const ItemContainer = () => {
  const match = useRouteMatch();
  const itemId = useMemo(() => match.params.id && getInt(match.params.id), [match]);

  return (
    <>
      <ItemGeneralDataContainer itemId={itemId} />
      {itemId && <ItemPropertiesContainer itemId={itemId} />}
    </>
  );
};

export default ItemContainer;
